import authentication from "./authentication";
import locale from "./locale";
import converters from "./converters";
import converterconfig from "./converterConfig";
import conversions from "./conversions";
import mdldata from "./mdldata";
import enabledownload from "./enabledownload";
import enableCRUD from "./enableCRUD";
import draggedConverter from "./draggedConverter";
import currentTimer from "./timerstatus";
import authnoaccess from "./authnoaccess";
import authrequiredpermissions from "./authrequiredpermissions";
import authcurrentpermissions from "./authcurrentpermissions";
import onlyOneFileAtTime from "./onlyOneFileAtTime";
import createdDefaultConverters from "./createdDefaultConverters";

import isConvertersManagerOpen from "./isConvertersManagerOpen";
import isConverterConfigOpen from "./isConverterConfigOpen";
import converterOnEdition from "./converterOnEdition";
export default {
  authentication,
  locale,
  converters,
  converterconfig,
  conversions,
  mdldata,
  enabledownload,
  enableCRUD,
  draggedConverter,
  currentTimer,
  authnoaccess,
  authrequiredpermissions,
  authcurrentpermissions,
  onlyOneFileAtTime,
  createdDefaultConverters,
  isConvertersManagerOpen,
  isConverterConfigOpen,
  converterOnEdition,
};
